import { chooseUsItems } from "../mock/ChooseUs";

const ChooseUs = () => {
  return (
    <section className="py-5">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h2 className="text-center">WHy Choose Us?</h2>
            <div className="text-center">
              <p style={{ maxWidth: "65%", margin: "0 auto" }}>
                Warraich traders was founded upon integrity, strong work ethic,
                our abilities, our people and our partners to provide our
                clients with the highest satisfaction.
              </p>
            </div>
          </div>
        </div>
        <div className="row my-5">
          {chooseUsItems.map((item) => (
            <div className="col-4" key={item.id}>
              <img src={item.imgSrc} alt="img" />
              <h4 className="my-3 text-secondary">{item.title}</h4>
              <p>{item.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ChooseUs;
